// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__eSL8E","legacyBtn":"MutateMid_legacyBtn__1Ga_7"};